
import { Enums } from '@bode-canada/core';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import regexps from '@/constants/regexps';

const { ListingStatusEnum, ListingOriginEnum } = Enums;

export default {
  name: 'ListingAddress',
  components: {
    Icon,
  },
  props: {
    listing: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IconType,
      StyleColorSchemeType,
    };
  },
  computed: {
    unit() {
      const { unit } = this.listing;

      return unit && unit.toString().match(regexps.startsWithNumber) ? `#${unit}` : unit;
    },
    tagName() {
      return this.isActive && !this.isSold ? 'a' : 'p';
    },
    isBode() {
      return this.listing.origin === ListingOriginEnum.BODE;
    },
    isSold() {
      return this.listing.status === ListingStatusEnum.SOLD;
    },
    link() {
      const {
        unit,
        address,
        city,
        community,
      } = this.listing;
      const addressQuery = `${unit || ''} ${address}, ${city || ''}, ${community || ''}`;

      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressQuery)}`;
    },
    addressClassNames() {
      return new StyleClassNamesBuilder('address__description')
        .addConditionClassName('white', this.isActive && this.isBode)
        .build();
    },
  },
};
